
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.372 8.81c-2.113 0-4.027.79-5.502 2.074L5.363 9.377C4.861 8.875 4 9.225 4 9.935v4.457a.8.8 0 00.797.797h4.457c.71 0 1.069-.86.566-1.363l-1.523-1.523a6.34 6.34 0 014.083-1.499 6.382 6.382 0 015.732 3.588.98.98 0 001.196.51 1 1 0 00.598-1.371c-1.371-2.79-4.225-4.72-7.534-4.72z"}})])
          )
        }
      }
    